export const defaultTerms = {
  version: "v0.0",
  description: "I accept the terms of use and verify that I am the sole owner of this intellectual property and am signing my life away by uploading it",
  url: "https://soundcloud.com/terms-of-use"
}
// Environments dev or prod
export const environment = process.env.VUE_APP_ENV_SHORTNAME;